enum Actors {
  None = 0,
  Company = 1,
  Employee = 2
}

export default Actors;
